import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { UserSurveyResponse } from '../models/user-survey-response';
import { UpdateUserSurveyStatus } from '../models/update-user-survey-status';

@Injectable({
  providedIn: 'root',
})
export class UserSurveyApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  static readonly UserSurveyPath = '/userSurvey';

  getUserSurveyStatus(userId: number): Observable<UserSurveyResponse | null> {
    return this.http.get<UserSurveyResponse | null>(`${this.rootUrl}${UserSurveyApi.UserSurveyPath}/${userId}`);
  }

  getUserSurveyUrl(): Observable<string | null> {
    return this.http.get<string | null>(`${this.rootUrl}${UserSurveyApi.UserSurveyPath}/url`);
  }

  updateUserSurveyStatus(payload: UpdateUserSurveyStatus): Observable<void> {
    return this.http.put<void>(`${this.rootUrl}${UserSurveyApi.UserSurveyPath}`, payload);
  }
}
